import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-relleno-linea',
  templateUrl: './relleno-linea.component.html',
  styleUrls: ['./relleno-linea.component.scss']
})
export class RellenoLineaComponent {

  images: any;
  dataMat: any;
  pesoUnitario: boolean = false;
  tamanobatch: boolean = false;
  batch: number = 0;
  tipoSeleccionado: string = '';
  tipoRelleno: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private distService: DistributionsService,
    private dialogRef: MatDialogRef<RellenoLineaComponent>,
  ) { }

  ngOnInit(): void {
    this.images = this.data.imgs;
    this.dataMat = this.data;
    this.pesoUnitario = this.data.bitPesoUnitario;
    this.tamanobatch = this.data.bitTamanoBatch;
    this.batch = this.data.batch;

    if (this.data.bitPesoUnitario === 1) {
      this.tipoSeleccionado = 'peso';
      this.tipoRelleno = 'peso (kg)';
    } else if (this.dataMat.bitTamanoBatch === 1) {
      this.tipoSeleccionado = 'batch';
      this.tipoRelleno = this.batch == 1 ? 'unidad' : 'unidades';
    }

    if(this.batch == null){
      this.batch = 1;
    }
  }

  saveConf() {

    if(this.tipoSeleccionado == 'peso'){
      this.pesoUnitario = true;
      this.tamanobatch = false;
    }
    if(this.tipoSeleccionado == 'batch'){
      this.tamanobatch = true;
      this.pesoUnitario = false;
    }

    let newObj = {
      id_mat_camp: this.data.id_mat_camp,
      batch: this.batch == null ? 0 : this.batch,
      bitPesoUnitario: this.pesoUnitario == true ? 1 : 0,
      bitTamanoBatch: this.tamanobatch == true ? 1 : 0
    }

    if (this.batch != null && this.batch < 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'No se aceptan cantidades negativas'
      })
    }
    else {
      this.distService.saveRellenoConf(newObj).subscribe(
        (result: any) => {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: ''
          })
        },
        (err: any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar'
          });
        }
      );
    }

  }

  onTipoChange() {
   
    if (this.tipoSeleccionado === 'peso') {
      this.tipoRelleno = 'peso (kg)';
    }
    else {
      this.tipoRelleno = 'unidades';
    }

  }

   soloEnteros(event: any) {
    const value = event.target.value;
       event.target.value = value.replace(/[^0-9]/g, '');
       this.batch = event.target.value;
  }

}
